import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";

const GeoLocationErrorPage = () => {
    const history = useHistory();

    useEffect(() => {
        navigator.geolocation.getCurrentPosition((position) => {
            history.push('/dashboard')
        }, err => {
        })
    }, [history])

    return (
        <h1>Please turn geolocation in order to continue the site</h1>
    )
}

export default GeoLocationErrorPage;